/**
 * @file Project board adapter.
 */

import { renderProjectKanban } from "../../shared/board/parentBoardKanban.js";
import { renderProjectWIPKanban } from "../../shared/board/parentBoardWipKanban.js";
import { renderProjectTable } from "../../shared/board/parentBoardTable.js";
import { createParentBoardAdapter } from "../../shared/board/parentBoardAdapterFactory.js";

export const projectBoardAdapter = createParentBoardAdapter({
  adapterKey: "project",
  viewKey: "projects",
  renderers: {
    table: renderProjectTable,
    kanban: renderProjectKanban,
    wipKanban: renderProjectWIPKanban,
  },
});
